import {_x} from '@wordpress/i18n';
import parse from 'html-react-parser';
import React from 'react';
import {Stack, Typography} from '@lapilli-ui/components';
import {YWCAS_IN_CATEGORY, YWCAS_LANG} from '../../../config';
const CategoryResult = ({query, singleCategory}) => {
    const categoryURL = singleCategory.url + '?ywcas=1&ywcas_filter='+query+'&lang='+YWCAS_LANG;
    return (
        <Stack direction="row" align='center' sx={{gap: '4px', paddingBottom: '10px'}} className='ywcas-category-result'>
            <Typography sx={{fontWeight: 'bold', fontSize:'0.93rem'}}>{query}</Typography>
            <Typography sx={{fontSize:'0.81rem', color:'#8F8080'}}>{YWCAS_IN_CATEGORY}</Typography>
            <a href={categoryURL}><Typography sx={{fontSize:'0.93rem',textTransform:'capitalize', color:'var(--wp--preset--color--contrast,#007565)'}}>{parse(singleCategory.name)}</Typography></a>
        </Stack>
    );
};
export default CategoryResult;